module.exports = __webpack_public_path__ + "img/swgf.91252a7c.png";